/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { LaunchGoogleMapsCommand } from './launch-google-maps.command';
import { Store } from '@ngxs/store';
import { MapService } from '../../services/map.service';
import { WindowRefService } from '../../../../core/ui/services/windowRef.service';

export function launchGoogleMapsFactory() {
    const command = new LaunchGoogleMapsCommand();
    command.setDependencies({
        store: inject(Store),
        mapService: inject(MapService),
        windowRef: inject(WindowRefService),
    });
    return command;
}
